<div class="survivorship" data-automation-id="survivorship-modal-container">
    <div class="header-bar top" data-automation-id="survivorship-modal-header">
        <button type="button" data-automation-id="survivorship-save-button" class="primary-button"
            (click)="saveChanges()" [disabled]="isSaveDisabled()" *ngIf="hasPermissions">Save</button>
        <button type="button" data-automation-id="survivorship-discard-changes-button" class="secondary-button"
            (click)="discardChanges()" [disabled]="isDiscardDisabled()" *ngIf="hasPermissions">Discard Changes</button>
        <button type="button" class="help-button" data-automation-id="survivorship-help-button" (click)="openHelp()">
            <i class="fa fa-question"></i>
        </button>
    </div>
    <form class="content" #contentForm="ngForm" data-automation-id="survivorship-content" [resBusySpinner]="isBusy"
        [message]="isBusyMessage">
        <res-key-value-list [placeholderField2]='"Enter query here ..."' [rows]="survivorshipRows"
            [nameColumnHidden]="true" [isDisabled]="!hasPermissions" automationId="survivorship-"
            [maxQueryLength]="1024" [prefixTemplate]="prefixTemplate" [isQueryValidationContext]="true"
            [isSurvivorshipComponent]="true" [settingsType]="settingsType">
        </res-key-value-list>
        <ng-template #prefixTemplate let-f="f">
            <div class="line-container">
                <span *ngIf="f" [ngClass]="{'disabled': !hasPermissions}">Deduplicate by:</span>
                <span *ngIf="!f" [ngClass]="{'disabled': !hasPermissions}">Then by:</span>
            </div>
        </ng-template>
    </form>
</div>